import React from "react";

const Pagination = ({
  currentPage,
  totalRows,
  perPage,
  onPageChange,
  onRowsPerPageChange,
  type,
}) => {
  // const totalPages = Math.ceil(totalRows / perPage);
  const totalPages = Math.max(1, Math.ceil(totalRows / perPage)); 
  const start = (currentPage - 1) * perPage + 1;
  const end = Math.min(currentPage * perPage, totalRows);

  const generatePageNumbers = () => {
    if (totalRows === 0) return [];  // No pages if no rows
    let pages = [];

    // Show only up to 5 pages at a time (smart pagination)
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);

    if (endPage - startPage < 4) {
      startPage = Math.max(1, endPage - 4);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  };

  return (
    <div className="flex flex-wrap justify-between items-center mt-6">
      {/* Rows per page + range */}
      <div className="flex items-center gap-3 text-sm text-gray-700">
        <span className="whitespace-nowrap">Show</span>
        {type !== "feeStructure" &&  (
        <select
          value={perPage}
          onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
          className="border border-gray-300 rounded px-2 py-1 text-sm"
        >
          {[5, 10, 20, 50, 100].map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
        )}
        <span className="whitespace-nowrap">{`${start} - ${end} of ${totalRows}`}</span>
      </div>

      {/* Pagination Buttons */}
      <div className="flex items-center gap-2 mt-2 sm:mt-0">
        {/* First Page */}
        <button
          onClick={() => onPageChange(1)}
          disabled={currentPage === 1}
          className={`w-8 h-8 rounded-xl border text-sm flex items-center justify-center ${
            currentPage === 1
              ? "text-gray-400 border-gray-300 cursor-not-allowed"
              : "text-primary_main border-primary_main hover:bg-[#7d4bdb41]"
          }`}
        >
          «
        </button>

        {/* Previous */}
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`w-8 h-8 rounded-xl border text-sm flex items-center justify-center ${
            currentPage === 1
              ? "text-gray-400 border-gray-300 cursor-not-allowed"
              : "text-primary_main border-primary_main hover:bg-[#7d4bdb41]"
          }`}
        >
          ‹
        </button>

        {/* Page Numbers */}
        {generatePageNumbers().map((page) => (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`w-8 h-8 rounded-xl border text-sm flex items-center justify-center ${
              currentPage === page
                ? "bg-primary_main text-white border-primary_main"
                : "text-primary_main border-primary_main hover:bg-[#7d4bdb41]"
            }`}
          >
            {page}
          </button>
        ))}

        {/* Next */}
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`w-8 h-8 rounded-xl border text-sm flex items-center justify-center ${
            currentPage === totalPages
              ? "text-gray-400 border-gray-300 cursor-not-allowed"
              : "text-primary_main border-primary_main hover:bg-[#7d4bdb41]"
          }`}
        >
          ›
        </button>

        {/* Last Page */}
        <button
          onClick={() => onPageChange(totalPages)}
          disabled={currentPage === totalPages}
          className={`w-8 h-8 rounded-xl border text-sm flex items-center justify-center ${
            currentPage === totalPages
              ? "text-gray-400 border-gray-300 cursor-not-allowed"
              : "text-primary_main border-primary_main hover:bg-[#7d4bdb41]"
          }`}
        >
          »
        </button>
      </div>
    </div>
  );
};

export default Pagination;
